export * from './LargeText.js';
